import { ReactNode, RefObject } from 'react';
import { StyledH1, StyledH2, StyledH3 } from './Heading.styles';

interface Props {
  variant: HeadingType;
  color?: HeadingColors;
  size?: string;
  children?: ReactNode;
  label?: boolean;
  className?: string;
  testId?: string;
  ellipsis?: boolean;
  contentEditable?: boolean;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  headingRef?: RefObject<HTMLHeadingElement | null>;
  spellCheck?: boolean;
}

const styledHeadings: Record<HeadingType, typeof StyledH1 | typeof StyledH2 | typeof StyledH3> = {
  h1: StyledH1,
  h2: StyledH2,
  h3: StyledH3,
};

const Heading = ({
  variant,
  color = 'black',
  size,
  children,
  label = false,
  className,
  testId,
  ellipsis,
  contentEditable,
  onFocus,
  onBlur,
  onKeyDown,
  headingRef,
  spellCheck,
}: Props) => {
  const StyledElement = styledHeadings[variant] || StyledH1;

  return (
    <StyledElement
      className={className}
      $isLabel={label}
      $size={size}
      $color={color}
      $ellipsis={ellipsis}
      data-testid={testId}
      contentEditable={contentEditable}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      ref={headingRef}
      spellCheck={spellCheck}
      suppressContentEditableWarning
    >
      {children}
    </StyledElement>
  );
};

export default Heading;
